module.exports = __webpack_public_path__ + "/login_ui/img/bo-30e99b54584f9fc77d2f04b6701a084a.svg";